import React, {Fragment} from 'react';
import formatMessage from '../../../utils/formatMessage';

const propertyInfo = (propertyType, messages) => {
    return (
        !!propertyType && (
            <Fragment>
                {messages.propertyType}
                {propertyType}
            </Fragment>
        )
    );
};

const bedroomsInfo = (bedrooms, messages) => {
    return (
        !!bedrooms && (
            <Fragment>
                {bedrooms}
                {formatMessage(messages.bedroomsFilterLabel, {bedroomsCount: bedrooms})}
            </Fragment>
        )
    );
};

const bathroomsFullInfo = (bathroomsFull, messages) => {
    return (
        !!bathroomsFull && (
            <Fragment>
                {bathroomsFull}
                {formatMessage(messages.bathroomsFilterLabel, {bathroomsCount: bathroomsFull})}
            </Fragment>
        )
    );
};

const bathroomsHalfInfo = (bathroomsHalf, messages) => {
    return (
        !!bathroomsHalf && (
            <Fragment>
                {bathroomsHalf}
                {messages.bathroomsHalfLabel}
            </Fragment>
        )
    );
};

const bathroomsToiletOnlyInfo = (bathroomsToiletOnly, messages) => {
    return (
        !!bathroomsToiletOnly && (
            <Fragment>
                {bathroomsToiletOnly}
                {messages.bathroomsToiletOnlyLabel}
            </Fragment>
        )
    );
};

const sleepsDetails = (sleeps, messages) => {
    return (
        !!sleeps &&
        formatMessage(messages.sleepsAbbreviation, {
            value: sleeps
        })
    );
};

const areaDetails = (area, isMetric, messages) => {
    return (
        !!area && (
            <Fragment>
                {area}
                {formatMessage(messages.areaLabelVerbose, {METRIC: isMetric})}{' '}
            </Fragment>
        )
    );
};

const ScreenReaderDetails = ({
    bedrooms,
    propertyType,
    bathroomsFull,
    bathroomsHalf,
    bathroomsToiletOnly,
    sleeps,
    area,
    isMetric,
    messages
}) => {
    return (
        <div className="sr-only">
            {propertyInfo(propertyType, messages)} {bedroomsInfo(bedrooms, messages)}{' '}
            {bathroomsFullInfo(bathroomsFull, messages)}{' '}
            {bathroomsHalfInfo(bathroomsHalf, messages)}{' '}
            {bathroomsToiletOnlyInfo(bathroomsToiletOnly, messages)}{' '}
            {sleepsDetails(sleeps, messages)} {areaDetails(area, isMetric, messages)}
        </div>
    );
};

export default ScreenReaderDetails;
